// Merker für Face ID / Touch ID / Fingerabdruck (Store-Build 1.0.1, Noah 12.10.2026).
// Bewusst winzig und ohne Abhängigkeiten: AuthContext, App und Dashboard lesen hier synchron,
// ob der Biometrie-Chunk (src/lib/biometrie.ts) überhaupt nachgeladen werden muss.
//
// Hier liegt KEIN Geheimnis, nur Schalterstände: welches Konto die schnelle Anmeldung nutzt und
// für welches Konto die App-Sperre an ist. Der Refresh-Token selbst liegt ausschließlich im
// iOS-Schlüsselbund bzw. Android-Keystore (biometrisch geschützt), nie im localStorage.
// Kein Tracking: diese Werte gehen nirgends hin (Regel „nichts auf dem Gerät speichern“ betrifft Messdaten).

const LOGIN_KEY = "cc_bio_login";
const NAME_KEY = "cc_bio_name";
const SPERRE_KEY = "cc_app_sperre";
const ANGEBOT_PREFIX = "cc_bio_angebot_";

function lesen(key: string): string | null {
  try { return window.localStorage.getItem(key); } catch { return null; }
}
function schreiben(key: string, value: string | null): void {
  try {
    if (value === null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  } catch { /* privat/gesperrt: dann eben ohne Merker */ }
}

/** Konto (auth user id), dessen Anmeldung per Biometrie auf diesem Gerät eingerichtet ist. */
export function biometrieLoginNutzer(): string | null { return lesen(LOGIN_KEY); }
export function biometrieLoginMerken(userId: string | null): void { schreiben(LOGIN_KEY, userId); }

/** Anzeigename der Biometrie beim Einrichten („Face ID“), für Texte ohne nativen Aufruf
 *  (Abmelden-Rückfrage, Sperrbildschirm). */
export function biometrieName(): string | null { return lesen(NAME_KEY); }
export function biometrieNameMerken(name: string): void { schreiben(NAME_KEY, name); }

/** Konto, für das die App-Sperre an ist (Standard: aus). */
export function appSperreNutzer(): string | null { return lesen(SPERRE_KEY); }
export function appSperreMerken(userId: string | null): void { schreiben(SPERRE_KEY, userId); }

/**
 * KUNDENTEXT-ENTWURF (Freigabe Noah): Abmelden-Rückfrage mit eingerichteter schneller Anmeldung.
 * Steht bewusst hier statt in biometrieTexte.ts: die Rückfrage liegt im Dashboard-Chunk, und ein
 * eigener Text-Chunk wäre eine zusätzliche Datei in der Start-Ladekette (check:bundle).
 */
export const BIOMETRIE_ABMELDEN_TEXTE = {
  text: (n: string) => `Mit ${n} meldest du dich danach ohne Passwort wieder an.`,
  behalten: "Abmelden",
  entfernen: (n: string) => `Abmelden und ${n} entfernen`,
} as const;

/** „Mit Face ID anmelden?“ wird je Konto und Gerät genau einmal angeboten. */
export function biometrieAngebotErledigt(userId: string): boolean { return lesen(ANGEBOT_PREFIX + userId) === "1"; }
export function biometrieAngebotMerken(userId: string): void { schreiben(ANGEBOT_PREFIX + userId, "1"); }
